import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_4 = {
  key: 1,
  class: "col-md-6 discount-value-field"
}
const _hoisted_5 = {
  key: 0,
  class: "discount-value-error"
}
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-header card-p border-0 pt-0" }
const _hoisted_11 = { class: "card-title align-items-start flex-column" }
const _hoisted_12 = { class: "card-label fw-bolder fs-3" }
const _hoisted_13 = { class: "card-body p-0" }
const _hoisted_14 = { class: "table-responsive" }
const _hoisted_15 = /*#__PURE__*/_createVNode("button", {
  class: "action-btn",
  type: "button",
  id: "action-trigger",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" })
], -1)
const _hoisted_16 = {
  class: "dropdown-menu dropdown-menu-end action-dropdown",
  "aria-labelledby": "action-trigger"
}
const _hoisted_17 = { class: "menu-item-wrapper" }
const _hoisted_18 = { class: "menu-item" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_20 = { class: "menu-item" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Select, {
        name: "priceGroup",
        target: "priceGroup",
        label: _ctx.$t('message.PRICE_GROUP'),
        placeholder: 'message.SELECT message.PRICE_GROUP',
        priceGroup: _ctx.priceGroup,
        "onUpdate:priceGroup": _cache[1] || (_cache[1] = ($event: any) => (_ctx.priceGroup = $event)),
        selectData: _ctx.priceGroups,
        value: _ctx.priceGroup,
        callEmit: true,
        clearable: true,
        filterable: true,
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePriceGroup(_ctx.priceGroup)))
      }, null, 8, ["label", "placeholder", "priceGroup", "selectData", "value"])
    ]),
    (_ctx.isEditProduct)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_Select, {
            name: "discountType",
            target: "discountType",
            label: _ctx.$t('message.DISCOUNT_TYPE'),
            placeholder: 'message.SELECT',
            discountType: _ctx.discountType,
            "onUpdate:discountType": _cache[3] || (_cache[3] = ($event: any) => (_ctx.discountType = $event)),
            selectData: _ctx.discountTypeOptions,
            value: _ctx.discountType,
            callEmit: true,
            clearable: true,
            onChange: _ctx.handleDiscountTypeChange
          }, null, 8, ["label", "placeholder", "discountType", "selectData", "value", "onChange"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isEditProduct)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_Input, {
            type: "number",
            name: "discountValue",
            label: _ctx.$t('message.DISCOUNT_VALUE'),
            placeholder: 'message.ENTER message.YOUR message.VALUE',
            discountValue: _ctx.discountValue,
            "onUpdate:discountValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.discountValue = $event)),
            target: "discountValue",
            value: _ctx.discountValue,
            disabled: !_ctx.discountType,
            min: 0
          }, null, 8, ["label", "placeholder", "discountValue", "value", "disabled"]),
          (_ctx.discountError)
            ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.discountError), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_Input, {
        type: "number",
        name: "specialPrice",
        label: `${_ctx.$t('message.SPECIAL_PRICE')}`,
        placeholder: 'message.ENTER message.YOUR message.VALUE',
        specialPrice: _ctx.specialPrice,
        "onUpdate:specialPrice": _cache[5] || (_cache[5] = ($event: any) => (_ctx.specialPrice = $event)),
        target: "specialPrice",
        value: _ctx.specialPrice,
        disabled: _ctx.isEditProduct
      }, null, 8, ["label", "placeholder", "specialPrice", "value", "disabled"])
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_el_button, {
        type: "primary",
        class: "mt-2 btn-custom",
        disabled: _ctx.priceGroupBtn,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addPriceGroup())),
        style: {"float":"right"}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.priceGroupId == undefined ? _ctx.$t('message.SAVE') : _ctx.$t('message.UPDATE')), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("h3", _hoisted_11, [
            _createVNode("span", _hoisted_12, _toDisplayString(`${_ctx.$t('message.PRICE_GROUPS')} ${_ctx.$t('message.LIST')}`), 1)
          ])
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            _createVNode(_component_Table, {
              columns: _ctx.columns,
              rows: _ctx.groupsList,
              pagination: _ctx.pagination,
              padding: 5,
              onHandleCurrentChange: _ctx.handleCurrentChange,
              loading: _ctx.loader
            }, {
              "cell-name": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item?.price_group?.name), 1)
              ]),
              "cell-discount_type": _withCtx(({ row: item }) => [
                _createTextVNode(_toDisplayString(item?.discount_type ? _ctx.$t(`message.${item.discount_type}`) : ''), 1)
              ]),
              "cell-actions": _withCtx(({ index: index }) => [
                _hoisted_15,
                _createVNode("div", _hoisted_16, [
                  _createVNode("div", _hoisted_17, [
                    _createVNode("div", _hoisted_18, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleEdit(index)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_19,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                      ], 8, ["onClick"])
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("a", {
                        onClick: ($event: any) => (_ctx.handleDelete(index)),
                        class: "menu-link me-1"
                      }, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                      ], 8, ["onClick"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"])
          ])
        ])
      ])
    ])
  ]))
}